import { render } from "./CoconutLoginModal.vue?vue&type=template&id=787c41e2&scoped=true"
import script from "./CoconutLoginModal.vue?vue&type=script&lang=js"
export * from "./CoconutLoginModal.vue?vue&type=script&lang=js"

import "./CoconutLoginModal.vue?vue&type=style&index=0&id=787c41e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787c41e2"]])

export default __exports__